import EngineeringIcon from "@mui/icons-material/Engineering";
import AssessmentIcon from "@mui/icons-material/Assessment";

export const reportGroups = [
  {
    title: "WGR Reports",
    icon: <EngineeringIcon color="primary" />,
    chipColor: "primary",
    reports: [
     
      {
        id: 1,
        name: "WGR",
        route: "/reports/1",
        state: {
          reportType: "WGR",
          title: "WORKSHOP GENERAL REGISTER",
        },
      },
      {
        id: 2,
        name: "WGR On Cost",
        route: "/reports/2",
        state: {
          reportType: "WGR1",
          title: "WORKSHOP GENERAL REGISTER (ON COST)",
        },
      },
       {
        id: 3,
        name: "Labour Sub Ledger",
        route: "/reports/3",
        state: {
          reportType: "LSL",
          title: "LABOUR SUB SHEET",
        },
      },
    ],
  },

  {
    title: "DSA Reports",
    icon: <AssessmentIcon color="success" />,
    chipColor: "success",
    reports: [
      {
        id: 4,
        name: "Divisional Allocation Summary",
        route: "/reports/4",
        state: {
          reportType: "DSA",
          title: "DIVISIONAL ALLOCATION SUMMARY",
        },
      },
    ],
  },

  {
    title: "Calculation Sheet",
    icon: <AssessmentIcon color="success" />,
    chipColor: "success",
    reports: [
      {
        id: 5,
        name: "IOH Repair Cost Input (C1)",
        route: "/reports/5",
        state: {
          reportType: "C1",
          title: "IOH Repair Cost Input (C1)",
        },
      },
      {
        id: 6,
        name: "POH Repair Cost Input (C2)",
        route: "/reports/6",
        state: {
          reportType: "C2",
          title: "POH Repair Cost Input (C2)",
        },
      },
      {
        id: 7,
        name: "IOH Data (C3)",
        route: "/reports/7",
        state: {
          reportType: "C3",
          title: "IOH Data (C3)",
        },
      },
      {
        id: 8,
        name: "POH Data (C4)",
        route: "/reports/8",
        state: {
          reportType: "C4",
          title: "POH Data (C4)",
        },
      },
      {
        id: 9,
        name: "Grand Summary (C5)",
        route: "/reports/9",
        state: {
          reportType: "C5",
          title: "GRAND SUMMARY (C5)",
        },
      },
      {
        id: 10,
        name: "Store Schedule (C6)",
        route: "/reports/10",
        state: {
          reportType: "C6",
          title: "STORE SCHEDULE (C6)",
        },
      },
      {
        id: 11,
        name: "Labour Schedule (C7)",
        route: "/reports/11",
        state: {
          reportType: "C7",
          title: "LABOUR SCHEDULE (C7)",
        },
      },
      {
        id: 12,
        name: "Freight & Proforma On Cost (C8)",
        route: "/reports/12",
        state: {
          reportType: "C8",
          title: "FREIGHT & PROFORMA ON COST (C8)",
        },
      },
      {
        id: 13,
        name: "Capital (C9)",
        route: "/reports/13",
        state: {
          reportType: "CAPITAL",
          title: "CAPITAL (C9)",
        },
      },
    ],
  },

  {
    title: "General Reports",
    icon: <AssessmentIcon color="success" />,
    chipColor: "success",
    reports: [
      {
        id: 14,
        name: "Shop Wise Cost Analysis - Labour",
        route: "/reports/14",
        state: {
          reportType: "SWCL",
          title: "SHOP WISE COST ANALYSIS - LABOUR",
        },
      },
      {
        id: 15,
        name: "Shop Wise Cost Analysis - Store",
        route: "/reports/15",
        state: {
          reportType: "SWCS",
          title: "SHOP WISE COST ANALYSIS - STORE",
        },
      },
      {
        id: 16,
        name: "Demand Wise Summary",
        route: "/reports/16",
        state: {
          reportType: "DWS",
          title: "DEMAND WISE SUMMARY",
        },
      },
      {
        id: 17,
        name: "Demand Wise Details",
        route: "/reports/17",
        state: {
          reportType: "DWD",
          title: "DEMAND WISE DETAILS",
        },
      },
      {
        id: 18,
        name: "Repair Cost Statement",
        route: "/reports/18",
        state: {
          reportType: "RCS",
          title: "REPAIR COST STATEMENT",
        },
      },
      {
        id: 19,
        name: "Store Schedule Statement",
        route: "/reports/19",
        state: {
          reportType: "SSS",
          title: "STORE SCHEDULE STATEMENT",
        },
      },
      {
        id: 20,
        name: "Under-Over Charge",
        route: "/reports/20",
        state: {
          reportType: "UOC",
          title: "UNDER-OVER CHARGE",
        },
      },
    ],
  },

  {
    title: "JV Reports",
    icon: <AssessmentIcon color="success" />,
    chipColor: "success",
    reports: [
      {
        id: 21,
        name: "JV 5",
        route: "/reports/21",
        state: {
          reportType: "SWCL",
          title: "JV 5 REPORT",
        },
      },
      {
        id: 22,
        name: "JV 6",
        route: "/reports/22",
        state: {
          reportType: "SWCS",
          title: "JV 6 REPORT",
        },
      },
      {
        id: 23,
        name: "JV 7",
        route: "/reports/23",
        state: {
          reportType: "DWS",
          title: "JV 7 REPORT",
        },
      },
      {
        id: 24,
        name: "JV Summery",
        route: "/reports/24",
        state: {
          reportType: "DWD",
          title: "JV Summery REPORT",
        },
      },
      {
        id: 25,
        name: "Capital JV",
        route: "/reports/25",
        state: {
          reportType: "RCS",
          title: "CAPITAL JV REPORT",
        },
      },
      {
        id: 26,
        name: "Store JV LIST",
        route: "/reports/26",
        state: {
          reportType: "SSS",
          title: "STORE DATA LIST",
        },
      },
      {
        id: 27,
        name: "Labour JV LIST",
        route: "/reports/27",
        state: {
          reportType: "UOC",
          title: "LABOUR DATA LIST",
        },
      },
    ],
  },



   {
    title: "Accounts Reports",
    icon: <AssessmentIcon color="success" />,
    chipColor: "success",
    reports: [
      {
        id: 28,
        name: "Work Shop Accounts",
        route: "/reports/28",
        state: {
          reportType: "SWCL",
          title: "Workshop Accounts",
        },
      },
      {
        id: 29,
        name: "Account Current Register (PART -I)",
        route: "/reports/29",
        state: {
          reportType: "SWCS",
          title: "Account Current Register (PART -I)",
        },
      },
      {
        id: 30,
        name: "Account Current Register (PART -II)",
        route: "/reports/30",
        state: {
          reportType: "DWS",
          title: "Account Current Register (PART -II)",
        },
      },
      {
        id: 31,
        name: "Actual Account",
        route: "/reports/31",
        state: {
          reportType: "DWD",
          title: "Actual Account",
        },
      },
     




      

    ],
  },
];